module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-fullheight",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "hero-body has-text-centered scrolling"
  }, [_c('div', {
    staticClass: "container overflow",
    class: {
      'is-top': _vm.isTop
    }
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28bdc349","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue-source/src/App.vue
// module id = 187
// module chunks = 0